export interface FetchMetaResponse {
  title: string;
  description: string;
}
